import sliceCreator from '../../index.jsx';
import {GET_MANDAL_BY_ID } from '../../../constants/index.jsx';
const _getMandalByIdAction = sliceCreator('GET_MANDAL_BY_ID', GET_MANDAL_BY_ID, 'get');

const { asyncAction: getMandalByIdAction, reducer, clearData: clearGetMandalByIdAction } = _getMandalByIdAction;

export default reducer;

export {
    getMandalByIdAction,
    clearGetMandalByIdAction
}